
import { defineComponent, h } from 'vue';
import { splitStringWithPlaceholders } from '@/Utils/StringUtility';
import { flattenSlotChildren } from '@/Utils/SlotUtility';
export default defineComponent({
    props: {
        tag: { type: String, default: 'span' },
        resource: { type: String, required: true },
    },
    computed: {
        availablePlaceholders() {
            return splitStringWithPlaceholders(this.resource, this.availableComponents);
        },
        availableComponents() {
            const attributeName = 'format-key';
            const components = flattenSlotChildren(this.$slots.default);

            return components.reduce((acc, component) => {
                const componentProps = component?.props ?? {};
                if (componentProps[attributeName]) {
                    acc[componentProps[attributeName]] = component;
                }
                return acc;
            }, {});
        },
    },
    render() {
        return h(this.tag, this.availablePlaceholders.map((part) => {
            if (typeof part === 'object') {
                const component = this.availableComponents[part.placeholder];
                return component;
            }
            return part;
        }));
    },
});
